import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { alphabeticallySort } from 'modules/core/components/Filters/computeOptions'
import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import locations from 'modules/locations/store/collections/locations'
import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import Condition from 'modules/reports/store/models/Condition'

interface Props {
  forms: ArgumentForm[]
}

const OfficeSelector = ({ forms }: Props) => {
  const form = forms[0]

  if (!form) return null

  const locationOptions = locations.models
    .slice()
    .sort(alphabeticallySort)
    .map((location) => ({
      value: location.attributes.name,
      label: location.attributes.name,
    }))

  const options: SelectOption[] = [
    {
      value: Condition.NOT_DEFINED,
      label: i18n.t(`custom_reports.especial_filters.not_defined`),
    },
    ...locationOptions,
  ]

  return (
    <FormRow>
      <Select
        none={i18n.t('custom_reports.especial_filters.employee_office.none')}
        label={i18n.t('custom_reports.especial_filters.employee_office.label')}
        field={form.get('value')}
        options={options}
      />
    </FormRow>
  )
}

export default observer(OfficeSelector)
